import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';
import _ from 'lodash';
import { sanitizeUrl } from '@jutro/platform';

export default class SgCardService {
    static manageBCPaymentInstrument(policyNumber, token, useCardForRenewal, paymentInsId, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cardService'),
            'manageBCPaymentInstrument',
            [policyNumber, token, useCardForRenewal, paymentInsId],
            additionalHeaders
        );
    }

    static getBarclayCardDetails(jobNumber, useCardForRenewal, screenHeight, screenWidth, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cardService'),
            'createBarclayCardRequest',
            [jobNumber, useCardForRenewal, screenHeight, screenWidth],
            additionalHeaders
        ).then((data) => {
            return data;
        });
    }

    static getCepBarclayCardDetails(policyNumber, jobNumber, branchNumber, useCardForRenewal, screenHeight, screenWidth, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cardService'),
            'createBarclayCardRequestCEP',
            [policyNumber, jobNumber, branchNumber, useCardForRenewal, screenHeight, screenWidth],
            additionalHeaders
        ).then((data) => {
            return data;
        });
    }

    static retrieveBarclayCardResponse(jobNumber, transactionUUID, useCardForRenewal, ipAddress, screenHeight, screenWidth, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cardService'),
            'getBarclayCardResponse',
            [jobNumber, transactionUUID, useCardForRenewal, ipAddress, screenHeight, screenWidth],
            additionalHeaders
        ).then((data) => {
            return data;
        });
    }

    static retrieveCepBarclayCardResponse(policyNumber, jobNumber, transactionUuid, branchNumber, useCardForRenewal,
        ipAddress, screenHeight, screenWidth, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cardService'),
            'getBarclayCardResponseCEP',
            [policyNumber, jobNumber, transactionUuid, branchNumber, useCardForRenewal, ipAddress, screenHeight, screenWidth],
            additionalHeaders
        ).then((data) => {
            return data;
        });
    }

    static validateBankAccount(sortCode, bankAccountNumber, jobNumber, amount, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cardService'),
            'validateBankAccount',
            [sortCode, bankAccountNumber, jobNumber, amount],
            additionalHeaders
        ).then((data) => {
            return data;
        });
    }

    static postToTarget(target, url, params, setIsDataLoaded) {
        const form = document.createElement('form');
        form.setAttribute('method', 'POST');
        form.setAttribute('action', url);
        form.setAttribute('target', target);
        form.setAttribute('id', 'paymentConfirmation');
        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                const hiddenField = document.createElement('input');
                hiddenField.setAttribute('type', 'hidden');
                hiddenField.setAttribute('id', key);
                hiddenField.setAttribute('name', key);
                hiddenField.setAttribute('value', params[key]);
                form.appendChild(hiddenField);
            }
        }
        // check if iframe element exists
        if (document.getElementById(target)) {
            document.body.appendChild(form);
            setIsDataLoaded(true);
            return form.submit();
        }
    }

    static setCPAinBCPaymentInstrument(jobNumber, transactionUUID, useCardForRenewal, token, instrID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cardService'),
            'setCPAinBCPaymentInstrument',
            [jobNumber, transactionUUID, useCardForRenewal, token, instrID],
            additionalHeaders
        );
    }

    static getBarclayCardDetailsDirectPayment(policyNumber, amount, useCardForRenewal, screenHeight, screenWidth, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('cardService'),
            'createBarclayCardRequestForDirectBillPayment',
            [policyNumber, amount, useCardForRenewal, screenHeight, screenWidth],
            additionalHeaders
        ).then((data) => {
            if (!_.isNil(data.hccUrl)) { // Need to add URL to trusted sources
                // eslint-disable-next-line no-param-reassign
                data.hccUrl = sanitizeUrl(data.hccUrl);
            }
            return data;
        });
    }

    static retrieveBarclayCardResponseDirectPayment(jobNumber, transactionUUID, amount, useCardForRenewal, ipAddress, screenHeight,
        screenWidth, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('cardService'),
            'getBarclayCardReponseForDirectBillPayment', [jobNumber, transactionUUID, amount, useCardForRenewal,
                ipAddress, screenHeight, screenWidth], additionalHeaders)
            .then((data) => {
                return data;
            });
    }

    static getBarclayCardDetailsToAddNewCard(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('cardService'),
            'createBarclayCardRequestToAddNewCard', [policyNumber], additionalHeaders)
            .then((data) => {
                if (!_.isNil(data.hccUrl)) { // Need to add URL to trusted sources
                    // eslint-disable-next-line no-param-reassign
                    data.hccUrl = sanitizeUrl(data.hccUrl);
                }
                return data;
            });
    }

    static replaceDefaultCard(policyNumber, barclayCardDto, publicId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('directBillPayment'),
            'replaceCard', [policyNumber, barclayCardDto, publicId], additionalHeaders)
            .then((data) => {
                return data;
            });
    }

    static payWithExistingCardBarclaycard(policyNumber, jobNumber, cardPublicID, branchNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('cardService'),
            'payWithExistingCardBarclaycard', [policyNumber, jobNumber, cardPublicID, branchNumber], additionalHeaders)
            .then((data) => {
                return data;
            });
    }

    static postPay(invoiceIds, barclayCardDTO, polNo, publicId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('directBillPayment'),
            'postPay_Ext', [invoiceIds, barclayCardDTO, polNo, publicId], additionalHeaders)
            .then(() => {
                return 'billing-make-payment-confirmation';
            });
    }
}
